import { render, staticRenderFns } from "./SponsorList-new.vue?vue&type=template&id=9bbee0c8"
import script from "./SponsorList-new.vue?vue&type=script&lang=js"
export * from "./SponsorList-new.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports